import { DisplayMenu, MenuAndProducts } from 'common/types/entities/mongo/menu'
import { WindowProduct } from 'common/types/entities/mongo/product'
import { fetchMenusThatHasProducts } from 'common/services/finder/menu'
import { ArrayUtils } from '@shopping/common'
import { fetchProducts } from 'common/services/product'
import { ProductParam } from 'common/types/params'
import { Sort } from 'common/constants'
import { fetchProductsWithZzim } from 'common/services/list'

export interface MenuByIngredients {
  selectedMenuId: string
  menuAndProductsArr: MenuAndProducts[]
  searchParam: ProductParam
}

const initialState: MenuByIngredients = {
  selectedMenuId: null,
  menuAndProductsArr: [],
  searchParam: null,
}

// action types
const INIT = 'homemeal/ingredients/INIT'
const SET_MENU = 'homemeal/ingredients/SET_MENU'
const TOGGLE_ZZIM = 'homemeal/ingredients/TOGGLE_ZZIM'

// action creators
export const initMenuByIngredients = (subVertical, ingredientsMenu, pageSize, headers) => async (
  dispatch,
  getState,
) => {
  if (getState().menuByIngredients.selectedMenuId) return

  const top5Menus: DisplayMenu[] = await fetchMenusThatHasProducts(subVertical, ingredientsMenu, pageSize).then(menus =>
    menus.slice(0, 5),
  )

  if (ArrayUtils.isEmpty(top5Menus)) return

  const firstMenu = ArrayUtils.getFirst(top5Menus)

  const searchParam = {
    subVertical,
    pageSize,
    page: 1,
    sort: Sort.POPULARITY,
    menuId: firstMenu.id,
  }
  const products: WindowProduct[] = await fetchProducts(searchParam)
    .then(result => result.products)
    .then(windowProducts => fetchProductsWithZzim(windowProducts, headers))

  const menuAndProductsArr = top5Menus.map(menu => makeMenuAndProducts(menu, firstMenu.id, products))

  dispatch({ type: INIT, result: { menuAndProductsArr, searchParam, selectedMenuId: firstMenu.id } })
}

const makeMenuAndProducts = (menu: DisplayMenu, targetMenuId: string, windowProducts: WindowProduct[]) => {
  const products = menu.id === targetMenuId ? windowProducts : []
  return { menu, products }
}

export const setMenuByIngredients = selectedMenuId => async (dispatch, getState) => {
  const state: MenuByIngredients = getState().menuByIngredients
  if (isProductFetched(state, selectedMenuId)) {
    dispatch({ type: SET_MENU, result: { ...state, selectedMenuId } })
    return
  }

  const searchParam = { ...state.searchParam, menuId: selectedMenuId }
  const products: WindowProduct[] = await fetchProducts(searchParam)
    .then(result => result.products)
    .then(windowProducts => fetchProductsWithZzim(windowProducts))

  const menuAndProductsArr = state.menuAndProductsArr.map(menuAndProducts => {
    if (menuAndProducts.menu.id !== selectedMenuId) return menuAndProducts
    return { ...menuAndProducts, products }
  })

  dispatch({ type: SET_MENU, result: { menuAndProductsArr, searchParam, selectedMenuId } })
}

const isProductFetched = (state: MenuByIngredients, selectedMenuId) =>
  state.menuAndProductsArr.some(
    menuAndProducts => menuAndProducts.menu.id === selectedMenuId && ArrayUtils.isNotEmpty(menuAndProducts.products),
  )

export const toggleZzim = (productId: string) => ({ productId, type: TOGGLE_ZZIM })

// reducer
export default (state: MenuByIngredients = initialState, action) => {
  switch (action.type) {
    case INIT:
    case SET_MENU:
      return { ...action.result }
    case TOGGLE_ZZIM:
      const menuAndProductsArr = state.menuAndProductsArr.map(menuAndProducts => {
        const products = menuAndProducts.products.map(product => {
          return product._id !== action.productId ? product : { ...product, isMyZzim: !product.isMyZzim }
        })
        return { ...menuAndProducts, products }
      })
      return { ...state, menuAndProductsArr }
    default:
      return state
  }
}
